import React, { useMemo } from "react";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import DialogDeleteShell from "./DialogDeleteShell";

function displayFileName(record, fallbackKey) {
  const file = _.get(record, "file", "");
  const ext = file.includes(".") ? file.substring(file.lastIndexOf(".")) : "";
  const baseName = _.get(record, fallbackKey) || _.get(record, "uploadedFileName") || file;
  return baseName && !String(baseName).includes(".") && ext ? baseName + ext : baseName;
}

export default function dialogSpineDelete(props) {
  const spineRecords = useMemo(
    () => (props.spines || []).filter((a) => a.animationSet === props.animationSetToDeleteID),
    [props.animationSetToDeleteID, props.spines]
  );
  const spineToSearch = spineRecords[0] || null;
  const assetNames = useMemo(
    () => spineRecords.map((r) => displayFileName(r, "uploadedFileName")).filter(Boolean),
    [spineRecords]
  );

  const handleDelete = (progressID) => {
    return fetch(getServerUri("spine/deleteAnimationSet"), {
      method: "DELETE",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        animationSetID: _.get(props, "animationSetToDeleteID", ""),
        progressID: progressID || "",
      }),
    }).then((response) => {
      if (response.status === 200) {
        const newSpines = props.spines.filter(
          (spine) => spine.animationSet !== props.animationSetToDeleteID
        );
        props.deleteAnimationSetFromSpines(props.animationSetToDeleteID);
        props.setSpines(newSpines);
        props.createSnackbar("Spine deleted", "success");
        props.onAfterDelete?.();
        return true;
      } else {
        response.text().then(console.log).catch(console.error);
        return false;
      }
    });
  };

  return (
    <DialogDeleteShell
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      assetNames={assetNames}
      assetID={_.get(spineToSearch, "_id")}
      assetFile={_.get(spineToSearch, "file")}
      assetType="spine"
      onConfirmDelete={handleDelete}
      createSnackbar={props.createSnackbar}
      errorMessage="An error occurred deleting the spine."
    />
  );
}
